import { GenericBackendResponse } from './genericBackendResponse';

export interface RankingSliceDto {
	position: number; // Posición en el ranking (1‑based)
	value: number; // Ahorro propio (empleado o media empresa)
	deltaToNext: number; // € necesarios para adelantar al siguiente
	positionsToGain: number; // puestos que subiría si lo consigue
	percentile: number; // Porcentaje de ranking (0-100)
}

export interface RankingUserDto {
	userId: string;
	userName: string;
	companyId: string;
	companyName: string;
}

export interface MyRankingResponseDto {
	rankingUpdatedAt: string; // ISO‑8601
	user: RankingUserDto;
	rankings: {
		employeeGlobal: RankingSliceDto;
		companyGlobal: RankingSliceDto;
		employeeCompany: RankingSliceDto;
	};
}

export type GetMyRankingResponse = GenericBackendResponse<MyRankingResponseDto>;

export default async function getMyRanking(token: string): Promise<GetMyRankingResponse> {
	const response = await fetch(`${process.env.REACT_APP_BASE_API}/users/me/ranking`, {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`
		}
	});

	if (!response.ok) {
		throw new Error('Network response was not ok');
	}

	const result: GetMyRankingResponse = await response.json();
	return result;
}
